import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "angle-right",
  "use": "angle-right-usage",
  "viewBox": "0 0 266 438",
  "content": "<symbol viewBox=\"0 0 266 438\" xmlns=\"http://www.w3.org/2000/svg\" id=\"angle-right\"><path d=\"M258.477 235.97L64.134 430.313c-9.373 9.373-24.569 9.373-33.941 0L7.526 407.646c-9.357-9.357-9.375-24.522-.04-33.901l154.02-154.746L7.485 64.254c-9.335-9.379-9.317-24.544.04-33.901L30.192 7.686c9.373-9.373 24.569-9.373 33.941 0l194.343 194.343c9.373 9.372 9.373 24.568.001 33.941z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol